import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Round } from '../../shared/model/poll.model';

@Component({
  selector: 'app-list-choices',
  templateUrl: 'list-choices.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./list-choices.component.less', '../../shared/common.less'],
})

export class ListChoicesComponent implements OnInit {
  @Input() isMobile: boolean;
  @Input() rounds: Array<Round>;
  @Input() votedStatuses: boolean[] = [];
  @Input() electionSelected: number;
  @Input() currentList: number = -1;
  @Output() setActiveListEvent = new EventEmitter<number>()
  @Output() setActiveElectionEvent = new EventEmitter<number>()


  ngOnInit() {    
    console.log("--");
    
    console.log(this.rounds);
    
  }

  setActiveList(event: number) {
    this.setActiveListEvent.emit(event)
  }

  setActiveElection(event: number) {
    this.setActiveElectionEvent.emit(event)
  }

}
